import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    storageKey: { type: String, default: 'onboardingCompleteBannerDismissed' }
  }

  initialize() {
  }

  connect() {
    // Check if banner was previously dismissed
    if (!localStorage.getItem(this.storageKeyValue)) {
      // Only show if not dismissed
      this.element.classList.remove('d-none')
    } else {
      // If dismissed, remove the element
      this.element.remove()
    }

    // Listen for Bootstrap's alert close event
    this.element.addEventListener('closed.bs.alert', () => {
      this.dismiss()
    })
  }

  disconnect() {
    console.log('onboarding complete banner controller disconnected')
  }

  dismiss() {
    // Store dismissal in local storage
    localStorage.setItem(this.storageKeyValue, 'true')
  }
}
